module.exports = __webpack_public_path__ + "static/media/cloud.3f419dd0.svg";